<template>
  <div
    class="modal fade"
    :class="{ show: isOpen }"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div
      class="modal-dialog"
      :class="{'modal-dialog-centered': centered, 'modal-lg': large}"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <slot name="title">
              title
            </slot>
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click.prevent="closeModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <slot name="body" />
        </div>

        <slot name="footer">
          <div
            v-if="needFooter"
            class="modal-footer"
          >
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click.prevent="closeModal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="onSubmit"
            >
              Save changes
            </button>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
const closeModal = function() {
	this.isOpen = false;

	document.querySelector("body").removeChild(this.backdrop);

	this.backdrop = null;
};

const openModal = function() {
	this.isOpen   = true;
	this.backdrop = document.createElement("div");
	this.backdrop.classList.add("modal-backdrop", "fade", "show");

	document.querySelector("body").appendChild(this.backdrop);
};

const data = () => (
	{
		isOpen: false,
		backdrop: null,
	}
);

export default {
	name: "BsModal",
	props: {
		// eslint-disable-next-line
		onSubmit: Function, 
		needFooter: {
			type: Boolean,
			default: false,
		},
		centered: {
			type: Boolean,
			default: false,
		},
		large: {
			type: Boolean,
			default: false,
		}
	},
	data,
	beforeDestroy() {
		if (this.isOpen) {
			this.closeModal();
		}
	},
	methods: {
		openModal,
		closeModal,
	}
};
</script>

<style>
  .modal.show {
    display: block;
    padding-right: 15px;
  }
</style>